import {
  DELIVERY_FILTER_ID,
  DELIVERY_WO_EXP_FILTER_ID,
  EXP_DELIVERY_FILTER_ID,
  PICKUP_FILTER_ID,
  PRICE_FILTER_ID,
  SORT_PARAM_ID,
} from '../consts';

const filterByIdGetter = (filterId) => (state) => state.filters.find((filter) => filter.id === filterId);

const appliedFilterValuesGetter = (filterId) => (_, getters) => getters.appliedFilters
  .find((filter) => filter.id === filterId)
  ?.values ?? [];

export default {
  namespaced: true,

  state: () => ({
    subqueryRef: '',
    subqueryRefWoFacets: '',
    productsCount: 0,
    filters: [],
    sort: '',
  }),

  getters: {
    filters: (state) => state.filters,
    productsCount: (state) => state.productsCount,

    subqueryRef: (state) => state.subqueryRef ?? '',
    subqueryRefPath: (state) => state.subqueryRef.split('?')?.[0] ?? '',
    subqueryRefParams: (state) => new URLSearchParams(state.subqueryRef.split('?')?.[1] ?? ''),
    subqueryRefWoFacets: (state) => state.subqueryRefWoFacets,

    priceFilter: filterByIdGetter(PRICE_FILTER_ID),
    pickupFilter: filterByIdGetter(PICKUP_FILTER_ID),
    deliveryFilter: filterByIdGetter(DELIVERY_FILTER_ID),
    deliveryWithoutExpressFilter: filterByIdGetter(DELIVERY_WO_EXP_FILTER_ID),
    expressDeliveryFilter: filterByIdGetter(EXP_DELIVERY_FILTER_ID),

    pickupFilterAppliedValues: appliedFilterValuesGetter(PICKUP_FILTER_ID),
    deliveryFilterAppliedValues: appliedFilterValuesGetter(DELIVERY_FILTER_ID),
    deliveryWithoutExpressFilterAppliedValues: appliedFilterValuesGetter(DELIVERY_WO_EXP_FILTER_ID),
    expressDeliveryFilterAppliedValues: appliedFilterValuesGetter(EXP_DELIVERY_FILTER_ID),

    appliedFilters: (state) => state.filters.filter(
      (it) => it.selected,
    ).map(
      (filter) => ({
        ...filter,
        values: filter.values.filter((it) => it.selected),
      }),
    ) ?? [],

    getAppliedFilterValues: (_, getters) => (filterId) => getters.appliedFilters
      .find((filter) => filter.id === filterId)
      ?.values ?? [],

    getFilter: (state) => (filterId) => state.filters.find((filter) => filter.id === filterId),
    sort: (state) => state.sort,
  },

  actions: {

    async loadFiltersData({ getters, commit }, url) {
      if (url === getters.subqueryRef) {
        return;
      }

      const filtersData = await this.$apiBFF.fetchCatalogFacets(url);

      commit('setFiltersData', filtersData);
    },

    /**
     * В текущем дизайне фильтров невозможно работать просто переходом по ссылкам, поэтому сохранена старая логика
     */
    applyFilter({ dispatch, getters }, { id, value } = {}) {
      if (!id || !value) {
        return;
      }
      const origFilter = getters.getFilter(id);
      const params = getters.subqueryRefParams;
      const key = `f-${origFilter.codeUrl}`;

      switch (id) {
        case PRICE_FILTER_ID: {
          const fromKey = `f-${origFilter.codeUrl}from`;
          const toKey = `f-${origFilter.codeUrl}to`;
          const { from, to } = value?.[0] ?? {};
          const { min, max } = origFilter?.values?.[0] ?? {};

          if (from === min && to === max) {
            params.delete(fromKey);
            params.delete(toKey);
          } else if (from && to && max && min) {
            params.set(fromKey, Math.max(from, min));
            params.set(toKey, Math.min(to, max));
          }
          break;
        }
        case PICKUP_FILTER_ID: {
          const values = (
            params.get(key)?.split(',')?.filter((v) => /^\D+$/.test(v)) ?? []
          ).concat(value.map((filterValue) => filterValue.value));

          if (values.length) {
            params.set(key, values);
          } else {
            params.delete(key);
          }

          break;
        }
        default: {
          const values = value.map((filterValue) => filterValue.value);

          if (values.length) {
            params.set(key, values);
          } else {
            params.delete(key);
          }
        }
      }

      const paramsString = params.toString();
      const url = paramsString.length ? `${getters.subqueryRefPath}?${paramsString}` : getters.subqueryRefPath;

      dispatch('loadFiltersData', url);
    },

    async applySort({ getters, dispatch }, value) {
      const params = getters.subqueryRefParams;

      if (params.has(SORT_PARAM_ID)) {
        params.delete(SORT_PARAM_ID);
      }
      params.set(SORT_PARAM_ID, value);

      const url = `${getters.subqueryRefPath}?${params.toString()}`;
      return dispatch('loadFiltersData', url);
    },

    clearAllFilters({ dispatch, state }) {
      dispatch('loadFiltersData', state.subqueryRefWoFacets);
    },
  },

  mutations: {
    setFiltersData: (state, {
      sort,
      productsCount,
      filters,
      subqueryRef,
      subqueryRefWoFacets,
    }) => {
      state.subqueryRef = subqueryRef;
      state.subqueryRefWoFacets = subqueryRefWoFacets;
      state.sort = sort;
      state.productsCount = productsCount;
      state.filters = filters;
    },
  },
};
